import cloneDeep from 'lodash/cloneDeep.js';
import { ALL_THEMES, fontMap, } from './constants/index.js';
import { mergeBorderRadii } from './mergeBorderRadii.js';
import { mergeColors } from './mergeColors.js';
export const computeMergedTheme = (brandTheme) => {
    const { baseTheme: theme, overrides, palette } = brandTheme;
    const { config } = cloneDeep(ALL_THEMES[theme]);
    return {
        borderRadius: mergeBorderRadii(config.borderRadius, overrides?.borderRadius ?? {}),
        colors: mergeColors(config.colors, overrides?.colors ?? {}, palette),
        font: fontMap[theme][overrides?.font?.pairing ?? config.font.pairing],
        palette,
        theme,
    };
};
//# sourceMappingURL=computeMergedTheme.js.map